import React, { Component } from "react";
import { connect } from "react-redux";
import { Link } from "react-router-dom";

// STATE AND STORE
// LIBS
import API from "../api";
import { loggedIn, logout } from "../api/jwt";
import { fetchMyUserIfNeeded } from "../actions/MyUserActions";
import { getDateFormat, getMonthFormat } from "../lib/helpers/dates";

// UI
import { Menu, P } from "../ui";
import IconDashboard from "../ui/src/ui/components/icons/dashboard";
import IconPaper from "../ui/src/ui/components/icons/paper";
import IconBill from "../ui/src/ui/components/icons/bill";
import IconClientBase from "../ui/src/ui/components/icons/clientBase";
import IconOffice from "../ui/src/ui/components/icons/office";
import IconUserAccount from "../ui/src/ui/components/icons/userAccount";
import IconCalendarToday from "../ui/src/ui/components/icons/calendarToday";
import IconCalendarMonth from "../ui/src/ui/components/icons/calendarMonth";
import IconSettings from "../ui/src/ui/components/icons/settings";

class GlobalMenu extends Component {
  constructor(props) {
    super(props);

    this.state = {
      search: "",
      searchNoResult: false,
      searchList: [],
      redirect: {
        link: null,
        is: false
      }
    };
  }

  componentDidMount() {
    if (loggedIn()) {
      const { dispatch, user } = this.props;
      dispatch(fetchMyUserIfNeeded(user));
    }
  }

  handleInputSearch = e => {
    const value = e.target.value;

    this.setState({ search: value });

    if (this.state.searchNoResult) {
      this.setState({
        searchList: [],
        searchNoResult: false
      });
    }
  };

  handleFormSubmit = async e => {
    e.preventDefault();

    const { search } = this.state;
    const resultSearch = await API.global.search(search);

    if (resultSearch) {
      // TODO: Поиск по вложенным документам (билеты, документы, залогодатели, пользователи)

      const searchList = resultSearch.map(item => {
        return <p>{JSON.stringify(item)}</p>;
      });

      this.setState({
        searchList,
        searchNoResult: false
      });
    } else {
      this.setState({
        searchList: [],
        searchNoResult: true
      });
    }
  };

  logoutHandler = () => {
    logout();

    window.location.pathname = "/";
  };

  render() {
    const user = this.props.user.item;

    // Если есть пользователь
    if (user.id !== "") {
      const optionsMenu = {
        // Заголовок меню
        name: "Управление ломбардом",
        // Ссылки для основного меню
        menu: [
          {
            type: "as",
            as: Link,
            link: `/dashboard`,
            title: "Главная",
            main: true,
            icon: <IconDashboard />
          },
          {
            type: "label",
            title: "База"
          },
          {
            type: "as",
            as: Link,
            link: `/bilets`,
            title: "Залоговые билеты",
            icon: <IconPaper />
            // }, {
            //   type: 'as',
            //   as: Link,
            //   link: `/depositors`,
            //   title: 'Залогодатели',
          },
          {
            type: "as",
            as: Link,
            link: `/blanks`,
            title: "Кассовые ордера",
            icon: <IconBill />
          },
          {
            type: "as",
            as: Link,
            link: `/depositors`,
            title: "Залогодатели",
            icon: <IconClientBase />
          },
          {
            type: "label",
            title: "Ломбард"
          },
          {
            type: "as",
            as: Link,
            link: `/filials`,
            title: "Филиалы",
            icon: <IconOffice />
          },
          {
            type: "as",
            as: Link,
            link: `/users`,
            title: "Пользователи",
            icon: <IconUserAccount />
          },
          {
            type: "label",
            title: "Отчёты"
          },
          {
            type: "as",
            as: Link,
            link: `/reports/day?date=${getDateFormat(new Date())}`,
            title: "За день",
            icon: <IconCalendarToday />
          },
          {
            type: "as",
            as: Link,
            link: `/reports/month?month=${getMonthFormat(new Date())}`,
            title: "За месяц",
            icon: <IconCalendarMonth />
          },
          {
            type: "label",
            title: "Система"
          },
          {
            type: "as",
            as: Link,
            link: `/settings`,
            title: "Настройки",
            icon: <IconSettings />
          }
        ],
        // Ссылки для помощи
        menuHelp: [
          {
            type: "link",
            blank: true,
            link: "http://help.malond.com/",
            title: "Как пользоваться поиском?"
          },
          {
            type: "link",
            blank: true,
            link: "https://malond.com/legal/terms",
            title: "Условия и соглашения"
          },
          {
            type: "link",
            blank: true,
            link: "https://malond.com/legal/privacy",
            title: "Политика конфиденциальности"
          }
        ],
        // Ссылки для приложений
        menuApps: [
          {
            type: "link",
            blank: true,
            link: "http://account.malond.com/apps/lombard",
            title: "Управление ломбардом"
          }
        ],
        // Ссылки для пользователя
        menuUser: [
          {
            type: "as",
            as: Link,
            link: "/settings/account",
            title: "Аккаунт"
          },
          {
            type: "as",
            as: Link,
            link: "/settings/account/edit",
            title: "Настройки"
          },
          {
            type: "hr"
          },
          {
            type: "button",
            button: {
              theme: "white",
              onClick: this.logoutHandler
            },
            // blank: true,
            // link: 'http://login.malond.com/auth/logout',
            title: "Выйти"
          }
        ],
        // Показывать поиск
        search: {
          show: false,
          focus: true,
          value: this.state.search,
          placeholder: "Введите № з/б и нажмите Enter...",
          handleInput: this.handleInputSearch,
          handleFormSubmit: this.handleFormSubmit,
          isNoResult: this.state.searchNoResult,
          noResult: (
            <P key="search-no-result" size="x-small" mutted text="center">
              Результатов нет
            </P>
          ),
          list: this.state.searchList
        },
        // Показывать кнопку продажи
        showSell: false,
        linkSell: "/operation",
        // Показывать правую панель
        showRightPanel: true,
        // Активное лого
        activeLogo: true
      };

      return <Menu options={optionsMenu} user={user} />;
    } else {
      return null;
    }
  }
}

const mapStateToProps = state => ({
  user: state.user
});

export default connect(mapStateToProps)(GlobalMenu);
